import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { setBootstrapInfoToLocal } from 'utils/js/bootstrapper';

const useGetBootstrapInfo = () => {
  const [loading, setLoading] = useState(true);
  const [bootstrapInfo, setBootstrapInfo] = useState(null);

  const { enqueueSnackbar } = useSnackbar();

  const getBootstrapInfo = () => {
    setLoading(true);

    axiosClient
      .get(`/SettingSystem/Bootstrapper`)
      .then(res => {
        if (res.status === 200) {
          const result = Object.fromEntries(
            res.data?.value?.map(item => [item.key, item.value]),
          );
          setBootstrapInfo(prev => {
            return result;
          });
          setBootstrapInfoToLocal(result);
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err?.message, { variant: 'error' }))
      .finally(() => setLoading(false));
  };

  return [getBootstrapInfo, loading, bootstrapInfo];
};

export default useGetBootstrapInfo;
